import { render, staticRenderFns } from "./ReplacementImportFromCommando.vue?vue&type=template&id=012e16cd"
import script from "./ReplacementImportFromCommando.vue?vue&type=script&lang=js"
export * from "./ReplacementImportFromCommando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports